<template>
  <v-navigation-drawer
    id="app-drawer"
    v-model="inputValue"
    app
    dark
    floating
    persistent
    mobile-break-point="991"
    width="260"
  >
    <v-img
      :src="image"
      :gradient="sidebarOverlayGradiant"
      height="100%"
    >
      <v-layout
        class="fill-height"
        tag="v-list"
        column
      >
        <img
                src="/img/logo.png"
                style="width: 50%;
    margin-left: 9%;"
                class="img-responsive center mb-3"

        />
        <v-divider/>
        <v-list-tile
          v-if="responsive"
        >
          <v-text-field
            class="purple-input search-input"
            label="Search..."
            color="purple"
          />
        </v-list-tile>
        <v-list-tile
          v-for="(link, i) in links"
          :key="i"
          :to="link.to"
          :active-class="color"
          avatar
          class="v-list-item"
        >
          <v-list-tile-action >
            <v-icon>{{ link.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-title
            v-text="link.text"
          />
        </v-list-tile>


      </v-layout>
    </v-img>
  </v-navigation-drawer>
</template>

<script>
// Utilities
import {mapMutations, mapState} from 'vuex'

export default {
  data: () => ({
    logo: 'https://i.pravatar.cc/300',
    links: [
      {
        to: '/list',
        icon: 'mdi-view-dashboard',
        text: 'List'
      },
      {
        to: '/add',
        icon: 'mdi-plus',
        text: 'Add'
      },
      {
        to: '/activity',
        icon: 'mdi-bell',
        text: 'Activity Log'
      },
      {
        to: '/change-password',
        icon: 'mdi-settings',
        text: 'Change Password'
      },

    ],
    logout:{
      icon: 'mdi-logout',
      text: 'Logout'
    },
    responsive: false
  }),
  computed: {
    ...mapState('app', ['image', 'color']),
    inputValue: {
      get() {
        return this.$store.state.app.drawer
      },
      set(val) {
        this.setDrawer(val)
      }
    },
    user() {
      return sessionStorage.getItem('USER');
    },
    user_type() {
      let user = sessionStorage.getItem('USER');
      user = user ? JSON.parse(user) : null
      if (user)
        return user.user_type;
    },
    items() {
      return this.$t('Layout.View.items')
    },
    sidebarOverlayGradiant() {
      return `${this.$store.state.app.sidebarBackgroundColor}, ${this.$store.state.app.sidebarBackgroundColor}`
    }
  },
  mounted () {
    this.onResponsiveInverted()
    window.addEventListener('resize', this.onResponsiveInverted)
    if (this.user_type === 'admin') {
      this.links.push({
        to: '/graph-list',
        icon: 'mdi-map',
        text: 'Graph List',
      });
      this.links.push({
        to: '/users',
        icon: 'mdi-account-group',
        text: 'Users List',
      });
      this.links.push({
        to: '/add-user',
        icon: 'mdi-account-plus',
        text: 'Add User',
      });
    }
    if(JSON.parse(sessionStorage.getItem('USER')).user.url.trim() !== ''){
      this.links.push({
        to: '/dashboard',
        icon: 'mdi-view-dashboard',
        text: 'Dashboard',
      });
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResponsiveInverted)
  },
  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
    onResponsiveInverted () {
      if (window.innerWidth < 991) {
        this.responsive = true
      } else {
        this.responsive = false
      }
    },

  }
}
</script>

<style lang="scss">
  #app-drawer {
    .v-list__tile {
      border-radius: 4px;

      &--buy {
        margin-top: auto;
        margin-bottom: 17px;
      }
    }

    .v-image__image--contain {
      top: 9px;
      height: 60%;
    }

    .search-input {
      margin-bottom: 30px !important;
      padding-left: 15px;
      padding-right: 15px;
    }

    div.v-responsive.v-image > div.v-responsive__content {
      overflow-y: auto;
    }
  }
</style>
